{
  "fileTypeNotSupported": "Тип файла не поддерживается",
  "fileSizeExceeded": "Размер файла превышает максимально допустимый размер 2 МБ",
  "searchByModel": "Поиск по модели",
  "mileageFrom": "Миля от",
  "mileageTo": "Миля до",
  "add": "добавить",
  "change": "сменить",
  "delete": "удалить",
  "language": "язык",
  "hello": "привет",
  "registration": "Регистрация",
  "forgetPassword": "Забыли пароль?",
  "mailText": "или войти через",
  "placeholderEmail": "Введите свой email",
  "placeholderPassword": "Введите пароль",
  "placeholderLogin": "Введите логин",
  "enter": "Вход",
  "bestOffer": "Лучшие предложения",
  "closestEvents": "Ближайшие события",
  "additionalInfo": "Дополнительная информация",
  "businessDifference": "Чем отличается ваш бизнес от остальных? Какие преимущества?",
  "placeholderDescribe": "Опишите",
  "businessIssues": "Какие проблемы в вашей компании ?",
  "businessPerspectives": "Какая перспектива вашего бизнеса ?",
  "businessReasons": "Причина продажи вашего бизнеса",
  "businessTrainingAdvice": "Вы проведете обучение и окажите консультации",
  "businessSupport": "Сможет ли его новый владелец рассчитывать на вашу помощь и поддержку ?",
  "location": "Местоположение",
  "city": "Город",
  "address": "Адрес",
  "pointBtn": "Указать точку на карте",
  "example": "Например",
  "contactInfo": "Контактная информация",
  "name": "Имя",
  "placeholderName": "Укажите имя",
  "placeholderContacts": "Контактный номер",
  "description": "Описание",
  "title": "Заголовок",
  "tags": "Все теги",
  "placeholderAddTag": "Добавить теги",
  "settingCost": "Установка стоимости",
  "placeholderPriceFrom": "Цена, от",
  "placeholderPriceBefore": "Цена, до",
  "placeholderPeriodPrice": "Период оплаты",
  "categoryTitle": "Категория",
  "paymentTitle": "Настройка оплаты",
  "placeholderSetPriceDollars": "укажите цену в долларах",
  "photo": "Фото",
  "estateTitle": "Подробная информация о недвижимости",
  "estateType": "Тип недвижимости",
  "placeholderChoose": "Выбрать",
  "roomAmount": "Количество комнат",
  "amenitiesTitle": "Удобства",
  "nearTitle": "Рядом находится",
  "area": "Площадь (кв. фут.)",
  "bathroom": "Количество ванных комнат",
  "workScheduleTitle": "График работы",
  "additionalTitle": "Дополнительный требования",
  "experienceTitle": "Опыт работы",
  "placeholderPoint": "Указать",
  "englishLevel": "Уровень английского",
  "workPermit": "Разрешение на работу",
  "workPeriod": "Период работы",
  "documents": "Документы",
  "currencyTitle": "Курсы валют",
  "aboutUs": "О нас",
  "contacts": "Контакты",
  "blog": "Блог",
  "map": "Карта сайта",
  "forBusiness": "Для бизнеса",
  "paidServices": "Платные услуги",
  "companyDetails": "Реквизиты компании",
  "support": "Поддержка",
  "privacyAgreement": "Соглашение о конфединциальности",
  "termsOfUse": "Правила использования",
  "helpAndFeedback": "Помощь и Обратная связь",
  "enterAndRegister": "Войти/Регистрация",
  "applyAds": "Подать объявление",
  "login": "Войти",
  "toFavorites": "В избранное",
  "share": "Поделиться",
  "adsAuthor": "Автор объявления",
  "adsAllAuthor": "Все объявления автора",
  "showPhone": "Показать контакты",
  "telegram": "Телеграм",
  "biziCommunities": "Сообщества BIZI в социальных сетях:",
  "preFooterText": "Все онлайн-объявления США на BIZI- здесь вы найдете то, что искали! Нажав на кнопку 'Подать объявление', вы сможете разместить объявление на любую тематику легко и быстро.С помощью сервиса BIZI вы сможете купить или продать из рук в руки практически все, что угодно.",
  "chicago": "Чикаго",
  "call": "Позвонить",
  "twoDaysAgo": "2 дня назад",
  "email": "Электронная почта",
  "myPhones": "Номер телефона",
  "phone": "Телефон",
  "personalData": "Личные данные",
  "changePassword": "Сменить пароль",
  "save": "Сохранить",
  "surname": "Фамилия",
  "middleName": "Отчество",
  "oldPassword": "старый пароль",
  "newPassword": "новый пароль",
  "confirmNewPassword": "подтвердите новый пароль",
  "allCategories": "Все категории",
  "noAds": "Нет активных объявлений",
  "createAdsText": "Подайте объявление, совершите выгодную сделку!",
  "createAds": "Создать объявление",
  "increaseSaleText": "Воспользовайтесь чтобы увеличить продажу услуг или товара",
  "aboutAuto": "Об авто",
  "vehicleBrand": "Марка машины",
  "vehicleModel": "Модель машины",
  "mileAge": "Пробег",
  "price": "Цена",
  "saveInDraft": "Сохранить в черновик",
  "publish": "Опубликовать",
  "recommendationsForYou": "Рекомендации для вас",
  "services": "Услуги",
  "filters": "Фильтры",
  "businessIn": "Бизнес в",
  "changeBtn": "Изменить",
  "negotiable": "Договорная",
  "fixed": "Фиксированная",
  "search": "Поиск",
  "profile": {
    "changePassword": "Сменить пароль",
    "messangers": "Мессенджеры",
    "socialMedia": "Социальные сети",
    "ads": "Объявления",
    "fav": "Избранное",
    "archive": "Архив",
    "settings": "Настройки",
    "support": "Служба поддержки",
    "logout": "Выход",
    "active": "Активные",
    "mod": "На модерации",
    "inactive": "Запланированно",
    "rejected": "Отклонено",
    "draft": "Черновик",
    "profile": "Профиль"
  },
  "notify": {
    "success": "Успешно",
    "add": "Объявление добавлено",
    "delete": "Объявление удалено"
  },
  "addTags": "Добавить теги",
  "firstPhotoOnBanner": "Первое фото будет на обложке объявления. Фото должно быть в формате .jpg",
  "makeMainBtn": "Сделать главным",
  "mainPhoto": "Главное фото",
  "photoDownloaded": "Загружено фото",
  "needUniqueDesignAds": "Уникальный дизайн рекламного объявления",
  "wantPublicationAds": "Разместить объявление на главной странице",
  "wantPublicationUpAds": "Разместить объявление вверху ленты",
  "placeholderMacExample": "Например, Macbook 16 pro",
  "enter16Symbols": "Введите не менее 16 символов",
  "enter40Symbols": "Введите не менее 40 символов",
  "yearOfIssue": "Год выпуска",
  "addPhoto": "Добавить фото",
  "forExample2Years": "Например два года",
  "linkToWebsite": "Ссылка на сайт",
  "placeholderEnterLink": "Вставить ссылку",
  "aboutBusiness": "О бизнесе",
  "whenBusinessWasCreated": "Сколько лет Вашему бизнесу",
  "numberOfCustomers": "Количество клиентов",
  "modelYear": "Год выпуска",
  "specifications": "Характеристики",
  "mileage": "Пробег",
  "carType": "Тип машины",
  "carMake": "Марка",
  "carModel": "Модель",
  "seeAll": "Смотреть все",
  "used_car": "подержаный",
  "new_car": "новый",
  "certified_pre_owned": "сертифицированный подержанный",
  "with_experience": "с опытом",
  "without_experience": "без опыта",
  "moreDetailed": "Подробнее",
  "fluent": "свободный",
  "yes": "да",
  "required": "требуется",
  "workingPermit": "РАзрешение на работу",
  "availabilityOfDocuments": "Наличие документов",
  "availabilityOfSsn": "Наличие SSN",
  "availabilityOfDl": "Водительские права",
  "driverLicenseUSA": "Водительские права (США)",
  "paymentSetup": "Зарплата",
  "paymentPerHour": "Почасовая оплата",
  "paymentRangePerHour": "Диапазон почасовой оплаты",
  "salaryPerMonth": "В месяц",
  "salaryRangePerMonth": "Диапазон месячной з/п",
  "salaryRangePerHourByMonth": "Диапазон почасовой оплаты в месяц",
  "businessInformation": "Информация о бизнесе",
  "businessInfoLifespan": "Как долго бизнес существует",
  "work": "Работа",
  "paymentPeriod": "Период оплаты",
  "profitRangePer": "Диапазон прибыли за",
  "profitPer": "Прибыль за",
  "businessTurnover": "Приблизительная прибыль и оборот",
  "businessProblems": "С какими проблемами сталкивается ваша компания?",
  "businessProspects": "Каковы перспективы вашего бизнеса?",
  "businessSaleReasons": "Причина продажи бизнеса?",
  "futureBusinessSupport": "Помощь в дальнейшем развитии",
  "More_then_1000": "> 1000",
  "Less_then_1000": "< 1000",
  "More_then_10000": "> 10000",
  "Year": "г.",
  "today": "сегодня",
  "dayAgo": "день назад",
  "daysAgoRuVar": "дня назад",
  "daysAgoEnVar": "дней назад",
  "Month": "мес.",
  "state": "Штат",
  "exampleAdsAddress": "Например, 1122 W Randolph St, Chicago, IL 60607",
  "telEmail": "Телефон и Email",
  "socialMedia": "Социальная сеть",
  "experience": "Опыт",
  "foundInCategories": "Найдено в категориях",
  "searchBtn": "Поиск",
  "auth": {
    "authError": "Неверный адрес электронной почты/номер телефона или пароль",
    "authEmailError": "Пожалуйста, введите действительный адрес электронной почты",
    "authPasswordError": "Пароль должен содержать не мение 8 символов, большие и маленькие буквы",
    "enterMail": "Электронная почта",
    "password": "Пароль",
    "name": "Ваше имя",
    "phone": "Ваш телефон",
    "emailInUse": "Эта почта уже используется",
    "invalidPhoneNumberFormat": "Неверный формат номера телефона"
  },
  "fieldIsRequired": "Это поле обязательно для заполнения",
  "requiredFields": "Заполните обязательные поля",
  "networkError": "Ошибка сети",
  "adsCreated": "Объявления успешно созданы",
  "basic": "базовый",
  "Less_then_year": "Меньше года",
  "More_then_year": "Больше года",
  "Years": "Года",
  "chooseCategory": "Выбрать категорию",
  "createBtn": "Создать",
  "reset": "Сбросить",
  "full_time": "Полная занятость",
  "part_time": "Неполная занятость",
  "estate": "Недвижимость",
  "auto": "Авто",
  "business": "Продажа бизнеса",
  "recommendedTags": "Рекомендуемые теги",
  "selectedTags": "Ваши теги",
  "noTags": "Нет тегов",
  "notFound": "не найдено",
  "negotiatedPrice": "Договорная цена",
  "vehicleType": "Состояние авто",
  "placeholderChooseModel": "модель",
  "show": "Показать",
  "resetFiltration": "Сбросить фильтры",
  "setUpHourPayment": "Укажите почасовую оплату",
  "rangePerHour": "Диапозон оплаты в час",
  "fromRangePayment": "От",
  "toRangePayment": "До",
  "rangePerMonth": "Диапазон зарплата в месяц",
  "setUpPayment": "Укажите заработную плату",
  "paymentPerMonth": "Зарплата в месяц",
  "turnOnPrice": "Включить цену",
  "photoMaximum": "Превышен максимальный лимит в 8 файлов",
  "buySell": "Куплю / Продам",
  "copied": "Скопировано!",
  "cost": "Цена",
  "disabled": "Отклоненный",
  "published": "Опубликовано",
  "editBtn": "Редактировать",
  "archiveBtn": "В архив",
  "deleteBtn": "Удалить",
  "restoreBtn": "Восстановить",
  "deleteItems": "Вы действительно хотите удалить безвозвратно  это объявление?",
  "toArchivedItems": "Вы действительно хотите деактивировать это объявление?",
  "toActivateItems": "Вы действительно хотите активировать  это объявление?",
  "cancel": "Отмена",
  "useNumber": "Использовать номер телефона",
  "useEmail": "Использовать почту",
  "sendToModeration": "Отправлено на модерацию",
  "adsUpdated": "Объявление обновлено",
  "noFavTitle": "Список желаемых пуст",
  "noFavBody": "Нет добавленных объявлений",
  "favAddBtn": "Добавить",
  "addedToFav": "Добавлено в избранное",
  "removedFromFav": "Удалено с избранных",
  "categoryTypeReason": "Тип категории не соответствует правилам",
  "bannerImageReason": "Изображение баннера не соответствует правилам",
  "subCategoryTypeReason": "Тип подкатегории не соответствует правилам",
  "startDateReason": "Дата начала не соответствует правилам",
  "completionDateReason": "Дата завершения не соответствует правилам",
  "headerReason": "Заголовок не соответствует правилам",
  "descriptionReason": "Описание не соответствует правилам",
  "workScheduleReason": "График работы не соответствует правилам",
  "additionalRequirementsReason": "Дополнительные требования не соответствует правилам",
  "paymentPerHourReason": "Оплата в час не соответствует правилам",
  "paymentPeriodReason": "Период оплаты не соответствует правилам",
  "paymentRangePerHourReason": "Диапазон оплаты в час не соответствует правилам",
  "salaryPerMonthReason": "Зарплата в месяц не соответствует правилам",
  "salaryRangePerHourByMonthReason": "Диапазон зарплаты в час по месяцам не соответствует правилам",
  "salaryRangePerMonthReason": "Диапазон зарплаты в месяц не соответствует правилам",
  "phoneAndEmailReason": "Телефон и электронная почта не соответствует правилам",
  "socialMediaReason": "Социальные медиа не соответствует правилам",
  "messengersReason": "Мессенджеры не соответствует правилам",
  "imagesReason": "Изображения не соответствует правилам",
  "addressReason": "Адрес не соответствует правилам",
  "tagsReason": "Теги не соответствует правилам",
  "makeVehicleReason": "Марка автомобиля не соответствует правилам",
  "modelYearReason": "Год выпуска не соответствует правилам",
  "mileageReason": "Пробег не соответствует правилам",
  "costReason": "Стоимость не соответствует правилам",
  "negotiatedPriceReason": "Договорная цена не соответствует правилам",
  "profitPerReason": "Прибыль за не соответствует правилам",
  "profitRangePerReason": "Диапазон прибыли за не соответствует правилам",
  "advantagesReason": "Преимущества не соответствует правилам",
  "problemsReason": "Проблемы не соответствует правилам",
  "prospectsForBusinessReason": "Перспективы бизнеса не соответствует правилам",
  "saleBusinessReason": "Продажа бизнеса не соответствует правилам",
  "typeOfEstateReason": "Тип недвижимости не соответствует правилам",
  "roomsReason": "Комнаты не соответствует правилам",
  "amenitiesReason": "Удобства не соответствует правилам",
  "nearbyReason": "Рядом не соответствует правилам",
  "costFromReason": "Стоимость от не соответствует правилам",
  "costToReason": "Стоимость до не соответствует правилам",
  "expirenceReason": "Опыт не соответствует правилам",
  "numberOfCustomerReason": "Количество клиентов не соответствует правилам",
  "vehicleTypeReason": "Тип транспортного средства не соответствует правилам",
  "salaryRangePerHourReason": "Диапазон заработной платы в час не соответствует правилам",
  "reason": "Причина",
  "subChapter": "Подраздел",
  "specifyTheNumberOfCustomers": "Укажите количество клиентов",
  "chooseFromTheList": "Выберите из списка",
  "enterANumber": "Введите число",
  "loginViaGoogle": "Войти с Google",
  "minimumLength16": "Минимальная длина 16 символов",
  "weOnSocials": "Мы в соц сетях",
  "successRegistration": "Регистрация завершена",
  "russian": "Русский",
  "english": "English",
  "biziBusiness": "Бизнес на BIZI",
  "marketingBizi": "Реклама на сайте",
  "privacyPolicy": "Политика конфиденциальности",
  "hideContacts": "Скрыть контакты",
  "quantity": "Количество ",
  "showMore": "Показать ещё",
  "fio": "ФИО",
  "authorContacts": "Контакты автора",
  "authorSocials": "Соц. сети автора",
  "textTo": "Написать в",
  "costType": "Тип цены",
  "saveAsDraft": "Сохранено в черновике",
  "continue": "Продолжить",
  "or": "Или",
  "any": "Любой",
  "numberOfRooms": "Кол-во комнат",
  "payment": "Оплата",
  "to": "До",
  "from": "От",
  "profit": "Прибыль",
  "profitFor": "Прибыль за",
  "invalidEmail": "Неверный формат почты",
  "main": "Главная",
  "notifications": "Уведомления",
  "maxLength150": "Максимальное количество символов 150",
  "upAds": "Поднять объявление",
  "mustBeGreater": "Должно быть больше, чем предыдущее поле",
  "no": "Нет",
  "availabilityOfUSALicense": "Наличие прав (США)",
  "addToArchive": "Добавлено в архив",
  "emptySearchResult": "Ничего не найдено",
  "totalSearchResults": "результатов",
  "home": "Главная",
  "saveInDraftMobile": "В черновик",
  "adsTags": "Теги",
  "theme": "Тема",
  "createDate": "Дата создания",
  "status": "Статус",
  "new": "Новый",
  "waiting_manager": "Ожидание специалиста",
  "waiting_client": "Ожидание клиента",
  "on_consultation": "Консультация",
  "closed": "Заяка закрыта",
  "apply": "Написать",
  "supportService": "Служба поддержки",
  "applicationSearch": "Поиск заявки",
  "allStatus": "Все статусы",
  "addThemeTitle": "Введите название темы",
  "message": "Введите текст",
  "claimCreated": "Обращение создано",
  "closeRequest": "Закрыть заявку",
  "hours": "часов",
  "hour": "час",
  "minute": "минута",
  "minutes": "минут",
  "ago": "назад",
  "send": "Отправить",
  "searchCity": "Поиск",
  "chooseCity": "Выберите город",
  "chooseState": "Выберите штат",
  "clearStateSelection": "Очистить выбор штата",
  "usa": "США",
  "shareThrough": "Поделиться через",
  "copyLink": "Или скопировать ссылку",
  "messageSend": "Отправлено",
  "noActiveChats": "Нет активных чатов.",
  "writeChat": "Написать заявку",
  "didntChoose": "Вы еще ничего не выбрали ",
  "searchByBrand": "Поиск по марке авто...",
  "searchByCity": "Поиск по городу...",
  "searchByState": "Поиск по штату...",
  "enterToSellAll": "Нажмите enter чтобы увидеть все результаты",
  "onlyPhotosLabel": "Только с изображениями",
  "yourTags": "Ваши тэги",
  "selectTagLabel": "Выберите тэг",
  "selectCityLabel": "Выберите город",
  "km": "км",
  "mi": "миль",
  "sendToModerationText": "Ваше объявление отправлено на рассмотрение. Оно будет опубликовано в ближайшее время.",
  "ok": "Ok",
  "1 Bathroom": "1 ванная",
  "2 Bathrooms": "2 ванные",
  "3 Bathrooms": "3 ванные",
  "4+ Bathrooms": "4 и более ванных",
  "sqft": "кв. фут",
  "baths": "ванны ",
  "reset-password": {
    "title": "Сброс пароля",
    "instruction": "Введите ваш email для получения ссылки на сброс",
    "emailLabel": "Email",
    "emailPlaceholder": "Введите ваш email",
    "newPasswordLabel": "Новый пароль",
    "newPasswordPlaceholder": "Введите новый пароль",
    "submit": "Отправить ссылку для сброса",
    "updatePassword": "Обновить пароль",
    "loading": "Загрузка...",
    "successMessage": "Ссылка для сброса отправлена на ваш email",
    "passwordUpdatedMessage": "Пароль успешно обновлен",
    "errorMessage": "Произошла ошибка. Пожалуйста, попробуйте снова",
    "backToLogin": "Вернуться к входу"
  },
  "faq": {
    "title": "Часто задаваемые вопросы (FAQ)",
    "questions": {
      "1": {
        "question": "Что такое Bizi?",
        "answer": "Bizi — это онлайн-платформа, на которой можно покупать, продавать и открывать различные товары и услуги. Мы создаем удобное пространство для безопасных сделок и взаимодействия между покупателями и продавцами. "
      },
      "2": {
        "question": "Кто может пользоваться Bizi?",
        "answer": "Bizi доступен для всех, включая людей и бизнесы из различных сообществ, которые ищут товары, услуги или возможности для продаж."
      },
      "3": {
        "question": "Как зарегистрироваться?",
        "answer": "Перейдите на сайт и нажмите «Регистрация».\nВведите свой электронный адрес или номер телефона и создайте пароль.\nПодтвердите аккаунт, и вы готовы к использованию!"
      },
      "4": {
        "question": "Как разместить товар на продажу?",
        "answer": "1.  Войдите в свой аккаунт.\n 2. Нажмите «Разместить товар».\n3.  Добавьте фотографии, описание, цену и выберите категорию товара.\n4.  Опубликуйте ваше объявление."
      },
      "5": {
        "question": "Бесплатно ли использовать Bizi?",
        "answer": "Да! Регистрация, просмотр и размещение товаров бесплатны. Дополнительные платные услуги доступны для повышения видимости ваших объявлений."
      },
      "6": {
        "question": "Как общаться с покупателями или продавцами?",
        "answer": "Вы можете использовать встроенную функцию сообщений для общения с покупателями или продавцами."
      },
      "7": {
        "question": "Какие товары можно продавать на Bizi?",
        "answer": "Вы можете продавать большинство товаров, включая мебель, электронику, одежду, транспортные средства и многое другое. Однако запрещены такие товары, как нелегальные изделия, оружие и поддельная продукция."
      },
      "8": {
        "question": "Как оставаться в безопасности при использовании Bizi?",
        "answer": "Встречайтесь в безопасных общественных местах.\nИспользуйте проверенные способы оплаты. \nНе делитесь личными данными."
      },
      "9": {
        "question": " Могу ли я редактировать или удалять свои объявления?",
        "answer": "Да, вы можете редактировать или удалять свои объявления в любое время."
      },
      "10": {
        "question": "Как сообщить о проблемах или подозрительных действиях?",
        "answer": "Используйте кнопку «Сообщить» на платформе или отправьте нам подробности на {email}."
      },
      "11": {
        "question": "Есть ли премиум-функции?",
        "answer": "Да, Bizi предлагает премиум-опции для повышения видимости ваших объявлений и охвата большего числа покупателей. Детали по ценам и функциям можно найти в настройках аккаунта."
      },
      "12": {
        "question": "Что делать, если мне нужна помощь?",
        "answer": "Наша служба поддержки всегда готова помочь вам! Свяжитесь с нами через раздел «Помощь» на сайте или в приложении, и мы ответим вам как можно скорее."
      }
    }
  },
  "marketing": {
    "marketingServices": "Платные услуги",
    "description": "Мы предлагаем платные маркетинговые услуги, которые помогут вашему бизнесу выделиться на платформе и привлечь больше клиентов. Используйте возможности для продвижения вашего бизнеса через наш сайт.",
    "bannerAds": "Рекламные баннеры",
    "bannerDescription": "Размещайте баннеры на главной странице или в других ключевых местах на нашем маркетплейсе для максимальной видимости. Мы предлагаем уникальные возможности для увеличения вашего охвата и привлечения целевой аудитории.",
    "benefitsTitle": "Преимущества:",
    "benefits": [
      "Индивидуальный дизайн баннера для вашего бизнеса.",
      "Стратегическое размещение на платформе для привлечения большего внимания.",
      "Привлечение новых клиентов и увеличение продаж."
    ],
    "pricingDetails": "Цены и подробности:",
    "pricingDescription": "Для получения информации о размещении баннеров и ценах, пожалуйста, свяжитесь с нами по адресу {email}.\n Наша команда поможет вам создать эффективную маркетинговую стратегию для вашего бизнеса.",
    "callToAction": "Свяжитесь с нами по адресу {email} для получения подробной информации и расценок."
  },
  "about-us": {
    "aboutUs": "О нас",
    "welcome": "Добро пожаловать в Bizi Inc. — онлайн-маркетплейс, который соединяет людей, бизнесы и возможности. Мы создали платформу, которая проста и удобна для покупок, продаж и открытия новых продуктов и услуг.",
    "goal": "Наша цель — создать безопасную и удобную среду для всех, кто ищет выгодные предложения, уникальные товары или желает продвигать свои предложения. Мы работаем с людьми и бизнесами из различных сообществ, предоставляя возможности для всех.",
    "joinUs": "Присоединяйтесь к Bizi Inc. и исследуйте наш растущий рынок, который объединяет людей и возможности!"
  },
  "for-business": {
    "page": {
      "title": "Для бизнеса",
      "intro": "Предлагаем бизнесам уникальные возможности для роста и повышения видимости с помощью платных услуг, которые помогут вам привлечь больше клиентов и выделиться среди конкурентов.",
      "whyChoose": {
        "title": "Почему выбрать Bizi?",
        "visibility": "Максимальная видимость: Разместите свои товары и услуги в самых популярных местах на платформе.",
        "professional": "Профессиональный подход: Мы предлагаем индивидуальные рекламные решения, которые соответствуют вашим бизнес-целям.",
        "promotion": "Эффективное продвижение: Привлекайте больше клиентов с помощью наших маркетинговых инструментов, таких как баннеры и платные объявления."
      },
      "contact": "Свяжитесь с нами по адресу {email} для получения информации о наших платных услугах и расценках. Мы поможем вам продвигать ваш бизнес и достичь новых высот!"
    }
  },
  "helpFeedback": {
    "title": "Помощь и Отзывы",
    "intro": "В Bizi Inc. мы ценим ваш опыт и всегда готовы вам помочь. Если у вас есть вопросы, требуется поддержка или вы хотите поделиться обратной связью, чтобы помочь нам стать лучше, не стесняйтесь обращаться к нам!",
    "help": {
      "title": "Как получить помощь",
      "faqs": "Часто задаваемые вопросы: Начните с посещения страницы с часто задаваемыми вопросами, чтобы найти ответы на распространенные вопросы.",
      "support": {
        "call": "Позвоните нам по номеру",
        "phone": "718-662-9695",
        "email": "Напишите нам по адресу",
        "liveChat": "Чат: Используйте функцию чата на нашем сайте, чтобы связаться с представителем службы поддержки в реальном времени."
      }
    },
    "feedback": {
      "title": "Поделитесь своими отзывами",
      "intro": "Ваши отзывы помогают нам улучшаться и создавать лучший опыт для вас.",
      "form": "Используйте форму обратной связи на нашем сайте, чтобы поделиться своими мыслями.",
      "email": "Отправьте предложения напрямую на"
    },
    "report": {
      "title": "Сообщите о проблемах",
      "intro": "Если вы столкнулись с подозрительными объявлениями, пользователями или техническими проблемами, пожалуйста, сообщите нам:",
      "button": "Используйте кнопку «Сообщить» на платформе.",
      "email": "Свяжитесь с нами напрямую с подробностями по электронной почте на"
    },
    "closing": "Мы стремимся сделать ваш опыт работы с Bizi удобным, безопасным и приятным. Спасибо, что вы являетесь частью нашего растущего сообщества!"
  },
  "companyDetailsPage": {
    "title": "Информация о компании",
    "name": {
      "title": "Название",
      "value": "Bizi Inc."
    },
    "businessType": {
      "title": "Тип бизнеса",
      "value": "Онлайн-платформа для торговли"
    },
    "mission": {
      "title": "Миссия",
      "value": "Соединять людей и компании через удобную, надежную и интуитивно понятную платформу для покупки, продажи и поиска товаров и услуг."
    },
    "whatWeDo": {
      "title": "Что мы делаем",
      "value": "Bizi Inc. создана для обслуживания различных сообществ, упрощая локальные транзакции и помогая пользователям находить выгодные предложения, уникальные товары или демонстрировать свои услуги. Будь вы покупатель или продавец, Bizi делает процесс соединения простым и эффективным."
    },
    "coreValues": {
      "title": "Основные ценности",
      "trust": "Доверие: Безопасная и надежная платформа для транзакций.",
      "convenience": "Удобство: Интуитивные инструменты, делающие процесс покупки и продажи простым.",
      "community": "Сообщество: Соединение людей и бизнеса для создания новых возможностей."
    },
    "contactInfo": {
      "title": "Контактная информация",
      "location": "Адрес: 1699 Wall Street, Suite 108, Mount Prospect, IL 60056",
      "phone": "Телефон: 718-662-9695",
      "website": "https://bizi.one"
    },
    "website": "веб-сайт"
  },
  "privacyPolicyPage": {
    "metaTitle": "Политика конфиденциальности",
    "title": "Политика конфиденциальности для BIZI",
    "lastUpdated": "Последнее обновление: {date}",
    "sections": {
      "1": {
        "title": "1. Информация, которую мы собираем",
        "points": {
          "1": "Личная информация: имя, адрес электронной почты, номер телефона и платежная информация.",
          "2": "Данные об использовании: информация о вашем взаимодействии с нашей платформой, включая IP-адрес, тип браузера и посещенные страницы."
        }
      },
      "2": {
        "title": "2. Как мы используем вашу информацию",
        "points": {
          "1": "Для предоставления и поддержки наших услуг.",
          "2": "Для обработки ваших транзакций и управления вашим аккаунтом.",
          "3": "Для общения с вами, включая ответы на запросы и отправку обновлений.",
          "4": "Для улучшения наших услуг на основе отзывов пользователей и данных об использовании."
        }
      },
      "3": {
        "title": "3. Права пользователей",
        "points": {
          "1": "Доступ: запрос копии информации, которую мы храним о вас.",
          "2": "Исправление: запрос исправления любой неточной или неполной информации.",
          "3": "Удаление: запрос на удаление вашей личной информации с учетом правовых обязательств.",
          "4": "Отказ: отказ от получения маркетинговых сообщений в любое время."
        }
      },
      "4": {
        "title": "4. Безопасность данных",
        "points": {
          "1": "Мы внедряем соответствующие технические и организационные меры для защиты вашей личной информации от несанкционированного доступа, потерь или неправомерного использования.",
          "2": "Однако ни один метод передачи данных через интернет или электронного хранения не является на 100% безопасным."
        }
      },
      "5": {
        "title": "5. Файлы cookie и технологии отслеживания",
        "points": {
          "1": "Мы используем файлы cookie и аналогичные технологии отслеживания для улучшения вашего опыта на нашей платформе.",
          "2": "Вы можете управлять настройками cookie через настройки вашего браузера."
        }
      },
      "6": {
        "title": "6. Передача вашей информации",
        "points": {
          "1": "Поставщики услуг: мы можем привлекать сторонние компании для предоставления наших услуг, такие как обработка платежей или анализ данных.",
          "2": "Юридические требования: мы можем раскрывать вашу информацию, если это требуется по закону или для защиты наших прав и прав других лиц."
        }
      },
      "7": {
        "title": "7. Ссылки на сторонние ресурсы",
        "points": {
          "1": "Наши услуги могут содержать ссылки на сторонние веб-сайты.",
          "2": "Мы не несем ответственности за политику конфиденциальности этих сайтов.",
          "3": "Мы рекомендуем вам ознакомиться с политикой конфиденциальности любых сторонних сайтов, которые вы посещаете."
        }
      },
      "8": {
        "title": "8. Изменения в этой политике конфиденциальности",
        "points": {
          "1": "Мы можем время от времени обновлять нашу политику конфиденциальности.",
          "2": "Мы уведомим вас о любых изменениях, разместив новую политику конфиденциальности на этой странице и обновив дату \"Последнее обновление\".",
          "3": "Мы рекомендуем вам периодически проверять эту политику на наличие изменений."
        }
      },
      "9": {
        "title": "9. Свяжитесь с нами",
        "points": {
          "1": "Если у вас есть вопросы или замечания по поводу этой Политики конфиденциальности или наших методов обработки данных, свяжитесь с нами по следующему адресу:"
        }
      }
    },
    "contactTitle": "BIZI",
    "contactEmail": "Электронная почта: {email}",
    "contactAddress": "Адрес: {address}"
  },
  "termsOfUsePage": {
        "title": "Условия использования BIZI",
        "sections": {
          "1": {
            "title": "1. Принятие условий",
            "content": "Добро пожаловать в BIZI. Получая доступ к нашей платформе или используя её, вы соглашаетесь соблюдать данные Условия использования. Если вы не принимаете эти условия, пожалуйста, воздержитесь от использования наших услуг. Соблюдение данных условий является важным для обеспечения безопасного и комфортного использования нашей платформы."
          },
          "2": {
            "title": "2. Требования к пользователю",
            "content": "Для создания аккаунта или использования нашей платформы вам должно быть не менее 18 лет. Используя BIZI, вы подтверждаете, что соответствуете этим требованиям, а также что предоставляемая вами информация во время регистрации является точной и правдивой."
          },
          "3": {
            "title": "3. Регистрация аккаунта и безопасность",
            "content": "Вы несёте ответственность за сохранение конфиденциальности данных своей учётной записи. Любая активность, осуществляемая под вашей учётной записью, находится под вашей ответственностью. Мы рекомендуем использовать сложные пароли и обеспечивать защиту вашей учётной информации."
          },
          "4": {
            "title": "4. Поведение и ответственность пользователей",
            "content": "Как ценного члена нашего сообщества, мы ожидаем от вас:• Предоставлять честную и точную информацию в ваших объявлениях и сделках.• Действовать в соответствии со всеми применимыми законами и нормативами.• Избегать мошеннической деятельности или публикации вводящего в заблуждение контента.• Воздерживаться от публикации или продажи запрещённых товаров (подробности см. в разделе «Запрещённый контент и действия»). Ваше сотрудничество важно для создания надёжного рынка."
          },
          "5": {
            "title": "5. Запрещённый контент и действия",
            "content": "Для поддержания безопасной и законной среды на BIZI пользователям строго запрещено:• Публиковать или продавать незаконные товары: Это включает любые предметы, продажа или владение которыми запрещены местным, государственным, национальным или международным законодательством. Примеры включают, но не ограничиваются:• Наркотики: Продажа или реклама контролируемых веществ, незаконных наркотиков или аксессуаров для их употребления.• Оружие, огнестрельное оружие или взрывчатые вещества.• Контрафактные товары или несанкционированные реплики.• Краденое имущество.• Товары, нарушающие права интеллектуальной собственности (например, пиратское программное обеспечение, нелегальные копии медиа).• Оскорбительный или вредный контент: Контент, пропагандирующий ненависть, насилие, оскорбления, домогательства или любую форму дискриминации, не будет терпеться.• Сексуально откровенный контент: Любой порнографический, сексуально откровенный или непристойный материал строго запрещён, включая, но не ограничиваясь:• Услуги для взрослых или эскорт.• Сексуально откровенные изображения или видео.• Товары или услуги, способствующие сексуальной эксплуатации или торговле людьми.• Опасные товары или услуги: Объявления, пропагандирующие опасные действия или незаконные услуги (например, хакерские услуги, торговля людьми, незаконные азартные игры), строго запрещены.• Ложные или мошеннические объявления: Любая ложная информация или искажение товаров или услуг запрещены. BIZI оставляет за собой право удалять любые объявления или контент, нарушающие данные правила. Нарушения могут привести к приостановке или прекращению действия аккаунта и судебному разбирательству, если это необходимо."
          },
          "6": {
            "title": "6. Сделки и оплата",
            "content": "BIZI — это платформа, которая связывает пользователей для покупки и продажи товаров. Мы не обрабатываем платежи и не осуществляем финансовые транзакции между пользователями. Все договорённости о ценах и оплате должны быть согласованы напрямую между пользователями. Пользователи несут полную ответственность за свои транзакции и соблюдение применимых законов и нормативов."
          },
          "7": {
            "title": "7. Сделки и споры",
            "content": "Мы содействуем взаимодействию между покупателями и продавцами, но не участвуем в самих сделках и не несём ответственности за качество, законность или безопасность выставленных товаров. Любые споры между пользователями должны разрешаться непосредственно между сторонами."
          },
          "8": {
            "title": "8. Платные услуги и комиссии",
            "content": "Некоторые функции нашей платформы могут быть платными, и информация о стоимости будет чётко указана на момент оформления сделки. Используя эти услуги, вы соглашаетесь оплачивать соответствующие комиссии. Обратите внимание, что все комиссии не подлежат возврату, если иное не требуется законом."
          },
          "9": {
            "title": "9. Контент, создаваемый пользователями",
            "content": "Пользователи могут размещать контент, например, описания товаров, отзывы и сообщения. Размещая контент, вы соглашаетесь, что он:• Не нарушает законы или нормативы.• Не является оскорбительным, клеветническим или вредным для других.• Не нарушает права интеллектуальной собственности третьих лиц. Мы оставляем за собой право удалять любой контент, нарушающий данные условия, или признанный недопустимым по нашему усмотрению."
          },
          "10": {
            "title": "10. Права интеллектуальной собственности",
            "content": "Весь контент на BIZI, включая логотипы, графику и текст, является интеллектуальной собственностью BIZI или наших лицензиаров. Вы не можете использовать, изменять или распространять любой наш контент без предварительного письменного согласия. Несанкционированное использование может привести к судебным разбирательствам."
          },
          "11": {
            "title": "11. Прекращение использования",
            "content": "Мы оставляем за собой право приостановить или прекратить действие вашего аккаунта в любое время, с причиной или без неё. Это включает, но не ограничивается, нарушениями данных Условий использования или подозрительной активностью, связанной с мошенничеством. В случае прекращения действия мы не обязаны сохранять или предоставлять доступ к данным вашего аккаунта."
          },
          "12": {
            "title": "12. Ограничение ответственности",
            "content": "BIZI предоставляется «как есть» без каких-либо гарантий, явных или подразумеваемых. Мы не несем ответственности за любые убытки, потери или сбои, которые могут возникнуть в результате использования нашей платформы, включая, но не ограничиваясь:• Потерей прибыли или деловых возможностей.• Потерей или повреждением данных.• Невозможностью доступа к нашей платформе из-за технических проблем."
          },
          "13": {
            "title": "13. Изменения условий",
            "content": "Мы оставляем за собой право вносить изменения в данные Условия использования в любое время. Любые изменения будут сообщены через нашу платформу и вступают в силу немедленно. Продолжение использования BIZI после внесения изменений означает ваше согласие с обновлёнными условиями."
          },
          "14": {
            "title": "14. Применимое законодательство",
            "content": "Данные Условия использования регулируются и толкуются в соответствии с законодательством штата Иллинойс. Любые споры, возникающие из данных условий, подлежат исключительной юрисдикции судов в Маунт-Проспекте, штат Иллинойс."
          },
          "15": {
            "title": "15. Контакты",
            "content": "Если у вас есть вопросы или замечания по поводу данных Условий использования, пожалуйста, свяжитесь с нашей службой поддержки по адресу {email} или посетите нас по адресу: BIZI, 1699 Wall Street, 108, Mount Prospect, IL 60056."
          }
      }
    }

}
